module.exports = __webpack_public_path__ + "img/steam.8ed473c7.svg";